import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createRequestWorkCalendarDataInTimeframeForProjects } from 'scenes/WorkDemo/utils/requests/createRequestGetWorkCalendarDataInTimeframeForProjects';
import returnProjectIdAndItsChildProjectIds from 'scenes/WorkDemo/utils/returnProjectIdAndItsChildProjectIds';
import { createSignedRequest } from '../../utils/createSignedRequest';

import { selectUserAdminBusinessIds } from 'scenes/Permissions/store/selectors/base-project-permissions.selectors';
import {
  selectProjects,
  selectSelectedProjectId,
} from 'store/projects/selectors/projectsSelectors';
import { loadRecordAllowancesOfEmployerInTimeframe } from 'store/recordAllowances/thunks/loadRecordAllowancesOfEmployerInTimeframe.thunk';
import { loadRecordAllowancesOfProjectInTimeframe } from 'store/recordAllowances/thunks/loadRecordAllowancesOfProjectInTimeframe.thunk';
import getCredentials from '../../utils/getCredentials';
import { loadAdminWorkCalendarDataFromExternalProject } from './loadAdminWorkCalendarDataFromExternalProject.thunk';

export const loadCalendarDataInTimeframe = createAsyncThunk(
  'workCalendar/loadCalendarDataInTimeframe',
  async (_, { getState, dispatch }) => {
    const { workSearchParams_demo } = getState();

    const state = getState();

    const selectedProjectId = selectSelectedProjectId(state);

    const projects = selectProjects(state);

    const userAdminBusinessIds = selectUserAdminBusinessIds(getState());

    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const selectedProject = projects[selectedProjectId];

    if (selectedProjectId && selectedProject?.businessTypeEnum === 'EMPLOYER') {
      dispatch(
        loadRecordAllowancesOfEmployerInTimeframe({
          fromDate: workSearchParams_demo.fromDate,
          toDate: workSearchParams_demo.toDate,
        })
      );
      const projectsToSearch = Object.values(projects)
        .filter(
          (project) => project.business_id === selectedProject.business_id
        )
        .map((project) => project.id);

      const requests = await Promise.all(
        projectsToSearch.map((projectId) => {
          const request = createRequestWorkCalendarDataInTimeframeForProjects(
            projectId,
            workSearchParams_demo.fromDate,
            workSearchParams_demo.toDate
          );
          return createSignedRequest(
            request,
            accessKeyId,
            secretAccessKey,
            sessionToken
          );
        })
      );

      const data = await Promise.all(
        requests.map((request) => axios(request).then((res) => res.data))
      );
      return data;
    } else if (selectedProjectId) {
      dispatch(
        loadRecordAllowancesOfProjectInTimeframe({
          fromDate: workSearchParams_demo.fromDate,
          toDate: workSearchParams_demo.toDate,
        })
      );
      if (userAdminBusinessIds && userAdminBusinessIds.length > 0) {
        await dispatch(loadAdminWorkCalendarDataFromExternalProject());
      }
      const projectsToSearch = returnProjectIdAndItsChildProjectIds(
        [selectedProjectId],
        Object.values(projects)
      );
      const requests = await Promise.all(
        projectsToSearch.map((projectId) => {
          const request = createRequestWorkCalendarDataInTimeframeForProjects(
            projectId,
            workSearchParams_demo.fromDate,
            workSearchParams_demo.toDate
          );
          return createSignedRequest(
            request,
            accessKeyId,
            secretAccessKey,
            sessionToken
          );
        })
      );

      const data = await Promise.all(
        requests.map((request) => axios(request).then((res) => res.data))
      );

      return data;
    } else {
      return;
    }
  }
);
